import {AbstractModel} from './abstract-model';

export class BotRule extends AbstractModel {
  id: number | null = null;
  position: number | null = null;
  name: string | null = null;
  rule: string | null = null;
  allowed: boolean = false;
}
